import { Position } from '../../shared/types/protocol.ts';
import { CustomEquipment, RecordPosition } from '../types/sharedTypeImpl.ts';


export function getUsedTool(
    positionVal: RecordPosition,
    position: Position,
    cmmEquipments: CustomEquipment[] | undefined
): string {
    let usedTool: string | undefined = undefined;
    if (positionVal.value && positionVal.equipmentId) {
        usedTool = cmmEquipments?.find(e => e._id === positionVal.equipmentId)?.displayName;
    } else {
        usedTool = position.toolType;
    }
    return usedTool ?? '';
}
